import { render, staticRenderFns } from "./DigitalReferenceQuestionsCard.vue?vue&type=template&id=dd066378&scoped=true"
import script from "./DigitalReferenceQuestionsCard.vue?vue&type=script&lang=ts"
export * from "./DigitalReferenceQuestionsCard.vue?vue&type=script&lang=ts"
import style0 from "./DigitalReferenceQuestionsCard.vue?vue&type=style&index=0&id=dd066378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd066378",
  null
  
)

export default component.exports